import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { Layout } from '@/components/layout/Layout'
import LoginPage from '@/pages/auth/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import UsersPage from '@/pages/users/UsersPage'
import UserFormPage from '@/pages/users/UserFormPage'
import TenantsPage from '@/pages/tenants/TenantsPage'
import TenantFormPage from '@/pages/tenants/TenantFormPage'
import DevicesPage from '@/pages/devices/DevicesPage'
import FormsPage from '@/pages/forms/FormsPage'
import FormBuilderPage from '@/pages/forms/FormBuilderPage'
import FormSubmissionsPage from '@/pages/forms/FormSubmissionsPage'
import WorkflowsPage from '@/pages/workflows/WorkflowsPage'
import WorkflowBuilderPage from '@/pages/workflows/WorkflowBuilderPage'
import WorkflowInstancesPage from '@/pages/workflows/WorkflowInstancesPage'
import RolesPage from '@/pages/users/RolesPage'
import ReportsPage from '@/pages/reports/ReportsPage'
import ProfilePage from '@/pages/ProfilePage'
import ReleasesPage from '@/pages/releases/ReleasesPage'
import HomeCardsPage from '@/pages/home-cards/HomeCardsPage'
import ActivityPage from '@/pages/activity/ActivityPage'
import AppLogsPage from '@/pages/logs/AppLogsPage'
import CategoriesPage from '@/pages/forms/CategoriesPage'
import SmtpSettingsPage from '@/pages/settings/SmtpSettingsPage'
import LabelsSettingsPage from '@/pages/settings/LabelsSettingsPage'
import AuditPage from '@/pages/settings/AuditPage'
import DepartmentsPage from '@/pages/master-data/DepartmentsPage'
import MasterDataAttributesPage from '@/pages/master-data/MasterDataAttributesPage'
import ClientesPage from '@/pages/clientes/ClientesPage'
import NotFoundPage from '@/pages/NotFoundPage'
import ProductionPage from '@/pages/production/ProductionPage'
import ProductionContainerPage from '@/pages/production/ProductionContainerPage'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="production" element={<ProductionPage />} />
          <Route path="production/containers/:containerId" element={<ProductionContainerPage />} />
          
          {/* Users */}
          <Route path="users" element={<UsersPage />} />
          <Route path="users/new" element={<UserFormPage />} />
          <Route path="users/:id/edit" element={<UserFormPage />} />
          
          {/* Tenants */}
          <Route path="tenants" element={<TenantsPage />} />
          <Route path="tenants/new" element={<TenantFormPage />} />
          <Route path="tenants/:id/edit" element={<TenantFormPage />} />
          
          {/* Devices */}
          <Route path="devices" element={<DevicesPage />} />
          
          {/* Forms */}
          <Route path="forms" element={<FormsPage />} />
          <Route path="forms/new" element={<FormBuilderPage />} />
          <Route path="forms/:id/edit" element={<FormBuilderPage />} />
          <Route path="forms/:id/submissions" element={<FormSubmissionsPage />} />
          <Route path="submissions" element={<FormSubmissionsPage />} />
          
          {/* Workflows */}
          <Route path="workflows" element={<WorkflowsPage />} />
          <Route path="workflows/new" element={<WorkflowBuilderPage />} />
          <Route path="workflows/:id/edit" element={<WorkflowBuilderPage />} />
          <Route path="workflows/instances" element={<WorkflowInstancesPage />} />
          
          {/* Reports */}
          <Route path="reports" element={<ReportsPage />} />

          {/* Releases */}
          <Route path="releases" element={<ReleasesPage />} />

          {/* Home Cards */}
          <Route path="home-cards" element={<HomeCardsPage />} />

          {/* Activity */}
          <Route path="activity" element={<ActivityPage />} />

          {/* Telemetry logs */}
          <Route path="logs" element={<AppLogsPage />} />

          {/* Form Categories */}
          <Route path="categories" element={<CategoriesPage />} />
          {/* Departments */}
          <Route path="departments" element={<DepartmentsPage />} />
          {/* Master Data Attributes */}
          <Route path="master-data/attributes" element={<MasterDataAttributesPage />} />
          {/* Clientes */}
          <Route path="clientes" element={<ClientesPage />} />

          {/* Roles management */}
          <Route path="roles" element={<RolesPage />} />

          {/* Settings */}
          <Route path="settings/profile" element={<ProfilePage />} />
          <Route path="settings/smtp" element={<SmtpSettingsPage />} />
          <Route path="settings/labels" element={<LabelsSettingsPage />} />
          <Route path="settings/audit" element={<AuditPage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
